<script>
  // Manual scope: branch + unit type, both required, nothing auto-suggested
  // (spec §2). Also hosts the per-reconciliation miss action (spec §5), which
  // is the header enum — Retire / Mark Lost / Leave Untouched — not a status.
  //
  // Changing the scope once decisions exist throws that work away, so
  // `changeScope` asks first and the selects snap back if the operator backs out.
  import { scope, missAction, changeScope } from "./store";

  export let branches = [];
  export let unitTypes = [];
  export let missActions = [];
  export let stacked = false;
  export let showMissAction = true;

  function pickBranch(e) {
    const branchId = e.target.value ? Number(e.target.value) : null;
    if (!changeScope({ branchId })) e.target.value = $scope.branchId ?? "";
  }

  function pickType(e) {
    const type = e.target.value || null;
    if (!changeScope({ type })) e.target.value = $scope.type ?? "";
  }
</script>

<div class={stacked ? "" : "d-flex flex-wrap gap-3 align-items-end"}>
  <div class={stacked ? "mb-2" : ""}>
    <label class="form-label small fw-bold mb-1" for="recon-branch">Branch</label>
    <select
      id="recon-branch"
      class="form-select form-select-sm"
      value={$scope.branchId ?? ""}
      on:change={pickBranch}
    >
      <option value="">Choose a branch…</option>
      {#each branches as b}
        <option value={b.id}>{b.name}</option>
      {/each}
    </select>
  </div>
  <div class={stacked ? "mb-2" : ""}>
    <label class="form-label small fw-bold mb-1" for="recon-type">Equipment type</label>
    <select
      id="recon-type"
      class="form-select form-select-sm"
      value={$scope.type ?? ""}
      on:change={pickType}
    >
      <option value="">Choose an equipment type…</option>
      {#each unitTypes as t}
        <option value={t.value}>{t.label}</option>
      {/each}
    </select>
  </div>
  {#if showMissAction}
    <div class={stacked ? "mb-2" : ""}>
      <label class="form-label small fw-bold mb-1" for="recon-miss-action">
        Units on hand that nobody scanned
      </label>
      <select
        id="recon-miss-action"
        class="form-select form-select-sm"
        value={$missAction}
        on:change={(e) => missAction.set(e.target.value)}
      >
        {#each missActions as action}
          <option value={action.value}>{action.label}</option>
        {/each}
      </select>
    </div>
  {/if}
</div>
